import React from "react";
import { Box } from "@mui/material";

const dumontSvg = require("./dumont.svg");

/**
 * Dumont logo for use in Ask Dumont sidebar and headers.
 * Accepts size and color like DumontLogo for consistent usage.
 */
export const DumontLogo: React.FC<{ size?: number; color?: string }> = ({
  size = 54,
  color = "#00A49F",
}) => {
  return (
    <Box
      component="span"
      role="img"
      aria-label="Dumont"
      sx={{
        width: size,
        height: size,
        display: "inline-block",
        flexShrink: 0,
        bgcolor: color,
        maskImage: `url(${dumontSvg})`,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        WebkitMaskImage: `url(${dumontSvg})`,
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
      }}
    />
  );
};

export default DumontLogo;